import React, { useState } from "react";
import styled from "styled-components";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

const faqs = [
  {
    question: "Which courses does LK Education offer?",
    answer:
      "LK Education provides a complete range of accounting and Tally training programs including Tally Essentials, Tally Professional, TallyPrime Basics, GST Using TallyPrime, TDS Using TallyPrime, Payroll Management, Accounting Basics Crash Course, and MS Office for Accountants. All programs are designed to make learners industry-ready with practical, real-world training."
  },
  {
    question: "Who are these courses suitable for?",
    answer:
      "Our courses are ideal for students, fresh graduates, job seekers, accountants, HR professionals, business owners, and anyone who wants to build a strong foundation in accounting and Tally. Whether you're a beginner or a working professional, we have a program tailored to your level."
  },
  {
    question: "Do you provide online and offline classes?",
    answer:
      "Yes! LK Education offers flexible learning options — online live sessions, offline classroom training, or hybrid mode where students can attend both. You also get recorded sessions, study materials, and continuous doubt-clearing support."
  },
  {
    question: "What is the difference between Tally Essentials and Tally Professional?",
    answer:
      "Tally Essentials is a beginner-to-intermediate program covering fundamentals, voucher entries, inventory, GST, payroll, and basic reporting. Tally Professional is an advanced program focusing on business automation, reconciliations, audits, complex transactions, financial control, and full business operations using TallyPrime."
  },
  {
    question: "Can I learn GST or TDS separately?",
    answer:
      "Yes. We offer dedicated practical courses for GST and TDS using TallyPrime. These include GST billing, reporting, RCM, E-way bills, ITC management, TDS setup, section-wise calculations, and preparation of compliance reports like GSTR and Form 26Q/24Q."
  },
  {
    question: "Do you provide practical training with real-life examples?",
    answer:
      "Absolutely. All our courses include hands-on practice, real business case studies, sample company data, and guided exercises. You will work on real accounting tasks, GST returns, payslips, reconciliations, invoices, and more to gain job-ready skills."
  },
  {
    question: "Will I get study materials and video recordings?",
    answer:
      "Yes. Students receive structured notes, reference materials, templates, and recorded video sessions. These help you revise concepts anytime and practice at your own pace."
  },
  {
    question: "Do you offer placement support?",
    answer:
      "Yes, we offer job assistance including resume building, interview preparation, internship guidance, and referrals to companies looking for Tally and accounting professionals."
  },
  {
    question: "Are certificates provided after course completion?",
    answer:
      "Yes. Upon successfully completing any course, students receive a professional certificate recognized by businesses and accounting firms, helping them improve their career prospects."
  },
  {
    question: "Is there any eligibility required to join these courses?",
    answer:
      "No specific eligibility is required. Even non-commerce students can join our Accounting Basics or TallyPrime Basics course. For advanced modules like GST, TDS, or Tally Professional, basic accounting knowledge is recommended."
  },
  {
    question: "Do you offer customized training for business owners?",
    answer:
      "Yes. We provide personalized training for business owners and staff, helping them manage accounting, billing, GST, payroll, and reporting efficiently using TallyPrime."
  },
  {
    question: "How can I enroll in a course?",
    answer:
      "You can simply contact us through WhatsApp, fill out the inquiry form, or visit our training center. Our team will guide you in selecting the right course based on your goals."
  }
];



const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleIndex = (i) => {
    setActiveIndex(activeIndex === i ? null : i);
  };
  const handleChatClick = () => {
  const message = "Hello, I would like to know more about LK Education’s Courses.";
  const encodedMessage = encodeURIComponent(message);
  window.open(`https://wa.me/979488687563?text=${encodedMessage}`, "_blank");
};


  return (
    <Wrapper>
      <Container>
        <Heading>Frequently asked questions</Heading>
        <Subheading>
          <span>💬</span> Still need help? <a onClick={handleChatClick}>Chat to us.</a>

        </Subheading>

        {faqs.map((faq, index) => (
          <AccordionItem key={index}>
            <Question onClick={() => toggleIndex(index)}>
              {faq.question}
              {activeIndex === index ? <FiChevronUp /> : <FiChevronDown />}
            </Question>
            <Answer active={activeIndex === index}>{faq.answer}</Answer>
          </AccordionItem>
        ))}
      </Container>
    </Wrapper>
  );
};

export default Faq;

// Styled Components
const Wrapper = styled.section`
  padding: 80px 20px;
  background: ${(props) => props.theme.colors.light};
`;

const Container = styled.div`
  max-width: 900px;
  margin: auto;
`;

const Heading = styled.h2`
  font-size: 2.2rem;
  font-weight: 700;
  margin-bottom: 10px;
  color: ${(props) => props.theme.colors.dark};
  text-align: center;
`;

const Subheading = styled.p`
  font-size: 1rem;
  color: #555;
  margin-bottom: 30px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;

  span {
    font-size: 1.2rem;
  }

  a {
    color: ${(props) => props.theme.colors.primary};
    text-decoration: none;
    font-weight: 600;
    cursor: pointer; /* ✅ cursor pointer */
    position: relative;
    transition: color 0.3s ease;

    &:hover {
      color: ${(props) => props.theme.colors.dark}; /* subtle hover */
    }

    /* underline animation on hover */
    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: -2px;
      width: 0%;
      height: 2px;
      background: ${(props) => props.theme.colors.primary};
      transition: width 0.3s ease;
    }

    &:hover::after {
      width: 100%; /* underline expands smoothly */
    }
  }
`;


const AccordionItem = styled.div`
  background: #fff;
  border-radius: 10px;
  margin-bottom: 15px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: box-shadow 0.3s ease;
  border: 1px solid ${(props) => props.theme.colors.medium}; /* ✅ added border */

  &:hover {
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  }
`;


const Question = styled.div`
  font-weight: 600;
  background: ${(props) => props.theme.colors.extralight};
  font-size: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${(props) => props.theme.colors.dark};
  padding: 20px;
  cursor: pointer;
  transition: background 0.3s ease;

  &:hover {
    background: ${(props) => props.theme.colors.medium};
    color: ${(props) => props.theme.colors.light};
  }

  svg {
    transition: transform 0.3s ease;
  }
`;


const Answer = styled.p`
  font-size: 0.95rem;
  background:${(props) => props.theme.colors.extralight};
  color: #444;
  line-height: 1.6;
  max-height: ${(props) => (props.active ? "1000px" : "0")};
  padding: ${(props) => (props.active ? "0 20px 20px 20px" : "0 20px")};
  opacity: ${(props) => (props.active ? "1" : "0")};
  transition: all 0.4s ease;
  overflow: hidden;
`;

